import React, { Component } from 'react'
import './index.less'

import score from 'src/helper/score'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'
import { toJS } from 'mobx'
import { isVoca } from 'src/helper/tool'

export default class extends Component {
  render() {
    let { lang, language } = this.props
    let lastRoomRank = this.props.lastRoomRank || []
    return (
      <div>
        <div className="room-last-week" style={{ display: `${lastRoomRank.length > 0 ? 'block' : 'none'}` }}>
          {/* <div className="room-last-week"> */}
          <div className="title">{lang.lastweek}</div>
          <div className="last-week-rank">
            <div
              className="rank-2"
              onClick={jumpToRoom.bind(this, lastRoomRank && lastRoomRank.length > 1 && lastRoomRank[1].gid)}
            >
              <img src="/img/activity/pk/r2.png" alt="" />
            </div>
            <div
              className="rank-1"
              onClick={jumpToRoom.bind(this, lastRoomRank && lastRoomRank.length > 0 && lastRoomRank[0].gid)}
            >
              <img src="/img/activity/pk/r1.png" alt="" />
            </div>
            <div
              className="rank-3"
              onClick={jumpToRoom.bind(this, lastRoomRank && lastRoomRank.length > 2 && lastRoomRank[2].gid)}
            >
              <img src="/img/activity/pk/r3.png" alt="" />
            </div>
          </div>
          {/* 头像 */}
          <div className="no2">
            <img src={(lastRoomRank && lastRoomRank.length > 1 && lastRoomRank[1].logourl) || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
          </div>
          <div className="no1">
            <img src={(lastRoomRank && lastRoomRank.length > 0 && lastRoomRank[0].logourl) || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
          </div>
          <div className="no3">
            <img src={(lastRoomRank && lastRoomRank.length > 2 && lastRoomRank[2].logourl) || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
          </div>
          {/* 头像 */}

          {/* 信息 */}
          <div className="user-info">
            <div className="user-no2">
              <div className="name">{(lastRoomRank && lastRoomRank.length > 1 && lastRoomRank[1].name) || ''}</div>
              <div className="id">ID:{(lastRoomRank && lastRoomRank.length > 1 && lastRoomRank[1].dgid) || ''}</div>
              <div className="money">
                <span>{score(lastRoomRank && lastRoomRank.length > 1 && lastRoomRank[1].val)}</span>
                <img src="/img/activity/pk/bs.png" alt="" />
              </div>
            </div>
            <div className="user-no1">
              <div className="name">{(lastRoomRank && lastRoomRank.length > 0 && lastRoomRank[0].name) || ''}</div>
              <div className="id">ID:{(lastRoomRank && lastRoomRank.length > 0 && lastRoomRank[0].dgid) || ''}</div>
              <div className="money">
                <span>{score(lastRoomRank && lastRoomRank.length > 0 && lastRoomRank[0].val)}</span>
                <img src="/img/activity/pk/bs.png" alt="" />
              </div>
            </div>
            <div className="user-no3">
              <div className="name">{(lastRoomRank && lastRoomRank.length > 2 && lastRoomRank[2].name) || ''}</div>
              <div className="id">ID:{(lastRoomRank && lastRoomRank.length > 2 && lastRoomRank[2].dgid) || ''}</div>
              <div className="money">
                <span>{score(lastRoomRank && lastRoomRank.length > 2 && lastRoomRank[2].val)}</span>
                <img src="/img/activity/pk/bs.png" alt="" />
              </div>
            </div>
          </div>
          {/* 信息 */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/pkactivity/RoomLastWeek/index.js